__turbopack_context__.v({
  "actionButtons": "Header-module__wra3da__actionButtons",
  "header": "Header-module__wra3da__header",
  "headerContainer": "Header-module__wra3da__headerContainer",
  "loginButton": "Header-module__wra3da__loginButton",
  "mobileHeader": "Header-module__wra3da__mobileHeader",
  "mobileHeaderSpacer": "Header-module__wra3da__mobileHeaderSpacer",
  "mobileMenu": "Header-module__wra3da__mobileMenu",
  "mobileMenuButton": "Header-module__wra3da__mobileMenuButton",
  "mobileMenuContent": "Header-module__wra3da__mobileMenuContent",
  "signUpButton": "Header-module__wra3da__signUpButton",
});
